import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

type HistoryData = {
  year: number;
  value: number;
};

type DataProps = {
  backgroundStyle?: boolean;
  lineColor?: string;
  pointColor?: string;
  title?: string;
  data: {
    name: string;
    history: HistoryData[];
  };
};

const LineChartPedagogico: React.FC<DataProps> = ({
  backgroundStyle = false,
  lineColor,
  pointColor,
  title,
  data
}) => {
  // 1) Extract the years and values from the history
  const years = data.history.map(h => h.year.toString());
  const values = data.history.map(h => h.value);

  // 2) Build the chart option using those arrays
  const option = {
    title: {
      text: title || `Histórico de score pedagógico do aluno: ${data.name}`,
      textStyle: { fontSize: '14px' },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: { backgroundColor: '#6a7985' },
      },
      formatter: (params: any) => {
        const { name, data: val } = params[0] || {};
        return `${name}: ${val}`;
      },
    },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: years,               // ← use your years here
    },
    yAxis: {
      type: 'value',
      axisLabel: { formatter: '{value}' },
    },
    series: [
      {
        name: 'Ano x Score pedagógico',
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 14,
        label: {
          show: true,
          position: 'top',
          color: pointColor || '#000',
          formatter: '{c}',
        },
        lineStyle: {
          color: lineColor || '#FC9F9F',
          width: 4,
        },
        itemStyle: {
          borderWidth: 1,
          color: lineColor || '#FC9F9F',
        },
        areaStyle: {
          color: backgroundStyle
            ? 'rgba(252, 159, 159, 0.6)'
            : 'transparent',
        },
        emphasis: { focus: 'series' },
        data: values,            // ← and your values here
      },
    ],
  } as ChartOption;

  return (
    <Box
      sx={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
      height="400px"
    >
      <Chart option={option} />
    </Box>
  );
};

export default LineChartPedagogico;
